import { render, staticRenderFns } from "./DlgCollapsiblePanel.vue?vue&type=template&id=0ca66282&scoped=true&lang=html&"
import script from "./DlgCollapsiblePanel.vue?vue&type=script&lang=js&"
export * from "./DlgCollapsiblePanel.vue?vue&type=script&lang=js&"
import style0 from "./DlgCollapsiblePanel.vue?vue&type=style&index=0&id=0ca66282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca66282",
  null
  
)

export default component.exports